import { Button, Checkbox, Space } from 'antd'
import { ButtonProps } from 'antd/lib'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  onPay?: () => void
  disabledPay?: boolean
} & ButtonProps

export const PayBrokerButton = ({
  onPay,
  disabledPay = false,
  ...props
}: Props) => {
  const { t } = useTranslation()
  const [isConfirmed, setIsConfirmed] = useState(false)

  const disabled = !isConfirmed || disabledPay

  return (
    <Space>
      <Checkbox
        checked={isConfirmed}
        onChange={({ target }) => setIsConfirmed(target.checked)}
      >
        {t('payment_has_been_collected')}
      </Checkbox>

      <Button
        disabled={disabled}
        type="primary"
        onClick={() => onPay?.()}
        {...props}
      >
        {t('confirm')}
      </Button>
    </Space>
  )
}
